import { render, staticRenderFns } from "./BaseImagePopout.vue?vue&type=template&id=bee275ba&scoped=true"
import script from "./BaseImagePopout.vue?vue&type=script&lang=js"
export * from "./BaseImagePopout.vue?vue&type=script&lang=js"
import style0 from "./BaseImagePopout.vue?vue&type=style&index=0&id=bee275ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee275ba",
  null
  
)

export default component.exports